import './SectionHeaderSmall.sass'

const SectionHeaderSmall = ({children}) => {
    return (
        <h2 className='section-header-small-title'>{children}</h2>
    );
};

export default SectionHeaderSmall;